import React from 'react';
import { Box, TextField } from '@mui/material';

interface WeightLosFieldsProps {
    weight: number;
    arithmeticMeanLOS: number;
    weightError?: string;
    losError?: string;
    onWeightChange: (value: number) => void;
    onLosChange: (value: number) => void;
}

export const WeightLosFields: React.FC<WeightLosFieldsProps> = ({
    weight,
    arithmeticMeanLOS,
    weightError,
    losError,
    onWeightChange,
    onLosChange
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
                label="Weight"
                type="number"
                value={weight}
                onChange={(e) => onWeightChange(parseFloat(e.target.value) || 0)}
                error={!!weightError}
                helperText={weightError}
                inputProps={{ min: 0, step: 0.0001 }}
                size="small"
                sx={{ flex: 1 }}
            />
            <TextField
                label="Arithmetic Mean LOS"
                type="number"
                value={arithmeticMeanLOS}
                onChange={(e) => onLosChange(parseFloat(e.target.value) || 0)}
                error={!!losError}
                helperText={losError}
                inputProps={{ min: 0, step: 0.01 }}
                size="small"
                sx={{ flex: 1 }}
            />
        </Box>
    );
};
